
export default class TravelPlanV2ViewModel {

    version: number | null = null;
    initialPlanMonth: number | null = null;
    initialPlanYear: number | null = null;
    currentPlanMonth: number | null = null;
    currentPlanYear: number | null = null;
    planAccredited: string | null = null;
    accreditingOrg: string | null = null;
    surveyYear: string | null = null;
    prevSurveyYear: string | null = null;
    nonTRICSSurveys: string | null = null;
    planType: string | null = null;
    bondCondition: string | null = null;
    hasCoordinator: string | null = null;
    coordinatorTime: string | null = null;
    annualBudget: string | null = null;
    devInitiatives1: string | null = null;
    devInitiatives2: string | null = null;
    targetResidents: string | null = null;
    targetStaff: string | null = null;
    targetVisitors: string | null = null;
    targetCustomers: string | null = null;
    targetStudents: string | null = null;
    targetPatients: string | null = null;
    targetAllUsers: string | null = null;
    targetOtherUsers: string | null = null;
    otherUserType: string | null = null;
    modalSplitBefore: string | null = null;
    modalDataMonth: number | null = null;
    modalDataYear: number | null = null;
    tripsVehicle: number | null = null;
    tripsCyclists: number | null = null;
    tripsPublicTransport: number | null = null;
    tripsPedestrians: number | null = null;
    tripsOther: number | null = null;
    modalDataSource: string | null = null;
    splitTargets: string | null = null;
    targetMonth: number | null = null;
    targetYear: number | null = null;
    targetTripsVehicle: number | null = null;
    targetTripsCyclists: number | null = null;
    targetTripsPublicTransport: number | null = null;
    targetTripsPedestrians: number | null = null;
    targetTripsOther: number | null = null;
    targetPlanYear: number | null = null;
    mainObjective: string | null = null;
    specificTargets: string | null = null;
    staffChange: string | null = null;
    staffChangeDetails: string | null = null;
    parkingChange: string | null = null;
    parkingChangeDetails: string | null = null;
    transportChange: string | null = null;
    transportChangeDetails: string | null = null;
    envFactors: string | null = null;
    envFactorsDetails: string | null = null;
    siteFactors: string | null = null;
    siteFactorsDetails: string | null = null;
    cycleParking: string | null = null;
    cycleParkingMonth: number | null = null;
    cycleParkingYear: number | null = null;
    cycleSheds: string | null = null;
    cycleShedsMonth: number | null = null;
    cycleShedsYear: number | null = null;
    cycleCompounds: string | null = null;
    cycleCompoundsMonth: number | null = null;
    cycleCompoundsYear: number | null = null;
    cycleSecurity: string | null = null;
    cycleSecurityMonth: number | null = null;
    cycleSecurityYear: number | null = null;
    showers: string | null = null;
    lockers: string | null = null;
    laundryService: string | null = null;
    bikeStorage: string | null = null;
    freeBreakfast: string | null = null;
    otherCycleFacility: string | null = null;
    otherCycleFacilityText: string | null = null;
    cyclingEvents: string | null = null;
    cyclingEventsMonth: number | null = null;
    cyclingEventsYear: number | null = null;
    cycleRoutes: string | null = null;
    cycleRoutesMonth: number | null = null;
    cycleRoutesYear: number | null = null;
    routesBeforeSite: boolean | null = null;
    routesToDestinations: string | null = null;
    resRoutesMonth: number | null = null;
    resRoutesYear: number | null = null;
    resRoutesBeforeSite: boolean | null = null;
    cycleComments: string | null = null;
    carSharing: string | null = null;
    carSharingMonth: number | null = null;
    carSharingYear: number | null = null;
    freeRideHome: string | null = null;
    freeRideHomeMonth: number | null = null;
    freeRideHomeYear: number | null = null;
    carShareParking: string | null = null;
    carShareParkingMonth: number | null = null;
    carShareParkingYear: number | null = null;
    carClubEmployees: string | null = null;
    carClubResidents: string | null = null;
    carClubMonth: number | null = null;
    carClubYear: number | null = null;
    carSharingComments: string | null = null;
    parkingRestricted: string | null = null;
    parkingRestrictedMonth: number | null = null;
    parkingRestrictedYear: number | null = null;
    parkingBeforeSite: string | null = null;
    parkingMeasures: string | null = null;
    parkingMeasuresMonth: number | null = null;
    parkingMeasuresYear: number | null = null;
    parkingCharges: string | null = null;
    parkingChargesMonth: number | null = null;
    parkingChargesYear: number | null = null;
    parkingEnforced: string | null = null;
    parkingEnforcedMonth: number | null = null;
    parkingEnforcedYear: number | null = null;
    eVBays: string | null = null;
    eVBaysMonth: number | null = null;
    eVBaysYear: number | null = null;
    eVBaysCount: number | null = null;
    eVBaysBeforeSite: string | null = null;
    parkingComments: string | null = null;
    seasonTicketLoan: string | null = null;
    seasonTicketLoanMonth: number | null = null;
    seasonTicketLoanYear: number | null = null;
    cyclingIncentives: string | null = null;
    cyclingIncentivesMonth: number | null = null;
    cyclingIncentivesYear: number | null = null;
    travelVouchers: string | null = null;
    travelVouchersMonth: number | null = null;
    travelVouchersYear: number | null = null;
    busVoucher: string | null = null;
    busVoucherValue: number | null = null;
    trainVoucher: string | null = null;
    trainVoucherValue: number | null = null;
    bikeVoucher: string | null = null;
    bikeVoucherValue: number | null = null;
    cycleTraining: string | null = null;
    cycleTrainingValue: number | null = null;
    otherVoucher: string | null = null;
    otherVoucherText: string | null = null;
    otherVoucherValue: number | null = null;
    incentivesComments: string | null = null;
    busStopsNearby: string | null = null;
    realTimeInfo: string | null = null;
    timetableDisplay: string | null = null;
    busShelter: string | null = null;
    busSeating: string | null = null;
    busDroppedKerbs: string | null = null;
    busStopMonth: number | null = null;
    busStopYear: number | null = null;
    busStopBeforeSite: string | null = null;
    newBusServices: string | null = null;
    newBusServicesMonth: number | null = null;
    newBusServicesYear: number | null = null;
    newBusBeforeSite: string | null = null;
    safeRoutesBus: string | null = null;
    safeRoutesBusMonth: number | null = null;
    safeRoutesBusYear: number | null = null;
    safeRoutesBusBeforeSite: string | null = null;
    safeRoutesRail: string | null = null;
    safeRoutesRailMonth: number | null = null;
    safeRoutesRailYear: number | null = null;
    safeRoutesRailBeforeSite: string | null = null;
    pTInfoProvided: string | null = null;
    residentWelcomePack: string | null = null;
    noticeboard: string | null = null;
    newsletters: string | null = null;
    staffInfoPack: string | null = null;
    journeyPlanning: string | null = null;
    travelWebsite: string | null = null;
    pTTimetables: string | null = null;
    otherPTInfo: string | null = null;
    otherPTInfoText: string | null = null;
    pTInfoMonth: number | null = null;
    pTInfoYear: number | null = null;
    pTComments: string | null = null;
    shuttleBusMain: string | null = null;
    shuttleBusMainMonth: number | null = null;
    shuttleBusMainYear: number | null = null;
    shuttleBusRail: string | null = null;
    shuttleBusRailMonth: number | null = null;
    shuttleBusRailYear: number | null = null;
    shuttleBusComments: string | null = null;
    marketingSuite: string | null = null;
    marketingSuiteInfo: string | null = null;
    marketingInfoMonth: number | null = null;
    marketingInfoYear: number | null = null;
    marketingTraining: string | null = null;
    marketingTrainingMonth: number | null = null;
    marketingTrainingYear: number | null = null;
    marketingComments: string | null = null;




}
